<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import { getStandardUnits, getDimensionalUnits } from '@/utils/units'
import { getBranches } from '@/utils/branch';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { getBrands } from '@/utils/brands'
import { permissionsMixin } from '@/mixins/userPermissions';

export default {
  mixins: [permissionsMixin],
  inject: ['setLoading'],  
  data() {
    return {
      low_stock_threshold: '',
      errors: {}, 
      id: '',
      code: '',
      type: 'product',
      branches: [],
      branch_ids: [],
      brands: [],
      brand_id: '',
      item_group_id: '',
      tax_id: '',
      name: '',
      unit: '',
      hsn_code: '',
      price: '',
      description: '',
      image: null,
      marketing_pdf: null,
      show_remove: 0,
      show_remove_pdf: 0,
      image_preview: null,
      marketing_pdf_preview: null,
      groups: [],
      taxes: [],
      units: [],
      dimensionalUnits: [],
      standardUnits: [],
      rmt_width_multiplier: '',
        rmt_height_multiplier: '',
      calculation_type: 'standard',
      inventory_type: 'finish',
      leaf_path: '',
      editorConfig: {
       toolbar: {
        items: ['bold', 'italic']
       },
      },
      editor: ClassicEditor,
      
      // Multi-level groups
      groupLevels: [],
      finalGroupId: '',
      loadingGroups: false,
      groupPath: []
    };
  },
  
  mounted() {
   this.setPermissions(this.auth);
  //  this.allBranches();
  //  this.allBrands();
},
  
  methods: {
async allBrands(){
  this.setLoading(true);
  try{
    const res = await getBrands();
    this.brands = res?.data?.data?.data || [];
  }catch(error){
    this.$swalToast(error.message,'error');
  }finally{
    this.setLoading(false);
  }
},

async fetchUnits(){
  try{
    const [standard, dimensional] = await Promise.all([
      getStandardUnits(),
      getDimensionalUnits()
    ]);
    this.standardUnits = standard;
    this.dimensionalUnits = dimensional;
    this.units = this.calculation_type === 'dimensional' ? this.dimensionalUnits : this.standardUnits;
  }catch(error){
    this.$swalToast(error.message, 'error');
  }
},

onCalculationTypeChange(){
  this.unit = '';
  this.units = this.calculation_type === 'dimensional' ? this.dimensionalUnits : this.standardUnits;
},

    async add(){
      await this.fetchUnits(); 
     this.resetForm();
     this.getGroups();
     this.getTaxes();
      this.allBranches();
      this.allBrands();
     this.marketing_pdf_preview = null;
     this.image_preview = null;
    },
    
    async editItem(item){
      await this.fetchUnits();
     this.getGroups();
     this.getTaxes();
     this.id = item.id;
     this.allBranches();
  this.allBrands();
     this.code = item.code || '';
     this.type = item.type;
     this.name = item.name;
     this.calculation_type = item.calculation_type || 'standard';
     this.inventory_type = item.inventory_type || 'finish';
    this.unit = item.unit || '';
    this.units = this.calculation_type === 'dimensional' ? this.dimensionalUnits : this.standardUnits;
     this.price = item.price;
     this.hsn_code = item.hsn_code || '';
     this.tax_id = item.tax_id || '';
     this.brand_id = item.brand_id || '';
     this.leaf_path = item.leaf_path || '';
     this.item_group_id = item.item_group_id || '';
     this.description = item.description || '';
     this.branch_ids = (item.branches || []).map(b => b.id);
     this.image_preview = item.image ? item.image_url : null;
     this.show_remove = item.image ? 1 : 0;
     this.marketing_pdf_preview = this.$clientImage(item.marketing_pdf, 'items', this.clientAdmin);
     this.show_remove_pdf = item.marketing_pdf ? 1 : 0;
     this.low_stock_threshold = item.low_stock_threshold || '';
     this.rmt_width_multiplier = item.rmt_width_multiplier || '';
this.rmt_height_multiplier = item.rmt_height_multiplier || '';
    },  
    
    async getGroups() {
     this.setLoading(true);
     this.loadingGroups = true;
      try {
       this.groupLevels = [];
       this.groupPath = [];
       this.finalGroupId = '';
        
       await this.loadLevelGroups(1);
        
       if(this.id && this.item_group_id){
        this.finalGroupId = this.item_group_id;
       }
      }catch(error){
       console.error('Groups error:', error);
       this.$swalToast(error.message, 'error');
      }finally{
       this.setLoading(false);
       this.loadingGroups = false;
      }
    },

    async loadLevelGroups(level) {
     this.loadingGroups = true;
     try {
      const parentId = this.getParentIdForLevel(level - 1);
      const parentPath = parentId ? `/${parentId}` : '';
  
      const response = await axios.get(`/item-groups/children${parentPath}`);
      const apiData = response.data.data;
    
      if(this.groupLevels.length < level){
       while(this.groupLevels.length < level){
        this.groupLevels.push([]);
      }
     }
    
     // Set this level
     this.groupLevels[level - 1] = apiData.map(group => ({
      id: parseInt(group.id),
      name: group.name,
      selected: false
     }));
    
     this.updateGroupPath();
    
   }catch(e){
    console.error('Load level error:', e);
    if(this.groupLevels[level - 1]){
     this.groupLevels[level - 1] = [];
    }
   }finally{
    this.loadingGroups = false;
   }
  },

  // Get parent ID from previous level
  getParentIdForLevel(level) {
   if (level === 0) return null;
   const previousLevel = this.groupLevels[level - 1];
   if (!previousLevel || previousLevel.length === 0) return null; 
   const selectedGroup = previousLevel.find(group => group.selected);
   return selectedGroup ? selectedGroup.id : null;
  },

  async onGroupLevelChange(level, event) {
   const selectedId = event.target.value;
  
   // Clear all previous selections
   this.groupLevels.forEach(lvl => {
    if(lvl){
     lvl.forEach(group => {
      group.selected = false;
     });
    }
   });

   if(selectedId && this.groupLevels[level]){
    const selectedGroup = this.groupLevels[level].find(group => group.id.toString() === selectedId);
    if(selectedGroup){
     selectedGroup.selected = true;
     this.finalGroupId = selectedGroup.id;
     // THIS LINE IS CRITICAL - LOAD NEXT LEVEL
     await this.loadLevelGroups(level + 2);
    }
   }else{
    this.finalGroupId = '';
   }
   this.updateGroupPath();
  },

  // Update breadcrumb path display
  updateGroupPath(){
   this.groupPath = [];
   this.groupLevels.forEach(level => {
   if(level){
    const selected = level.find(group => group.selected);
     if(selected){
      this.groupPath.push(selected);
     }
    }
   });
    
   if(this.groupPath.length > 0){
    this.finalGroupId = this.groupPath[this.groupPath.length - 1].id;
   }
  },

  async getTaxes(){
   this.setLoading(true);
   try{
    const response = await axios.get('/taxes');
    this.taxes = response.data.data;
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  }, 

  handleImageUpload(event) {
  const file = event.target.files[0];
  this.image = file;
  if(file){
    this.image_preview = URL.createObjectURL(file);
  }else{
    this.image_preview = null;  // ← change karo
  }
},

  handleMarketingPdfUpload(event) {
   const file = event.target.files[0];
   this.marketing_pdf = file;
   if(file){
    this.show_remove_pdf = 1;
   }else{
    this.show_remove_pdf = 0;
   }
  },

  async submitItem() {
   this.errors = {};
   this.setLoading(true); 

    try {
     const formData = new FormData();
     formData.append('id', this.id || '');
     formData.append('code', this.code);
     formData.append('type', this.type);
     formData.append('name', this.name);
     formData.append('price', this.price);
     formData.append('unit', this.unit || '');
    formData.append('calculation_type', this.calculation_type);
    formData.append('inventory_type', this.inventory_type);

     if (this.finalGroupId) formData.append('item_group_id', this.finalGroupId);
     if (this.tax_id) formData.append('tax_id', this.tax_id);
     if (this.brand_id) formData.append('brand_id', this.brand_id);
     if (this.hsn_code) formData.append('hsn_code', this.hsn_code);
     if (this.description) formData.append('description', this.description);
     if (this.image) formData.append('image', this.image);
     if (this.marketing_pdf) formData.append('marketing_pdf', this.marketing_pdf);
     if (this.low_stock_threshold) formData.append('low_stock_threshold', this.low_stock_threshold);
     if (this.rmt_width_multiplier) formData.append('rmt_width_multiplier', this.rmt_width_multiplier);
    if (this.rmt_height_multiplier) formData.append('rmt_height_multiplier', this.rmt_height_multiplier);

     this.branch_ids.forEach(id => {
      formData.append('branch_ids[]', id);
     });

     let response;
     if(this.id){
      response = await axios.post('/items/update', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
     }else{
      response = await axios.post('/items/create', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
     }
        
     this.$swalToast(response.data.message);
     this.$emit('updated', response.data.data);
     this.$closeModal('item_modal');
     this.resetForm();
    }catch(error){
     if(error.type == 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    }
   },

   async deleteItem() {
    this.errors = {};
    this.setLoading(true); 
    try{
     const response = await axios.delete(`/items/${this.id}/delete`);
     this.$swalToast(response.data.message);
     this.$emit('updated');
     this.$closeModal('item_delete_modal');
    }catch(error){
     if(error.type == 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error'); 
     }
    }finally{
     this.setLoading(false);
    }
   }, 

   async removeFile(){
    const result = await this.$confirm({});
    if(result.isConfirmed){ 
     this.setLoading(true);
     try{
      const response = await axios.delete(`/items/${this.id}/image/remove`);
      this.$swalToast(response.data.message);
      this.$emit('updated'); 
      this.$closeModal('item_modal');
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     } 
    }
   },

   async removeMarketingPdf(){
    const result = await this.$confirm({});
    if(result.isConfirmed){
     this.setLoading(true);
     try{
      const response = await axios.delete(`/items/${this.id}/marketing_pdf/remove`);
      this.$swalToast(response.data.message);
      this.$emit('updated');
      this.show_remove_pdf = 0;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    }
   },

   async allBranches(){
    this.setLoading(true);
    try{
     this.branches = await getBranches();
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
   },  

   openGroupModal() {
    const modalEl = document.getElementById('group_modal');
    const modal = new Modal(modalEl);
    modal.show();
    
    setTimeout(() => {
     const parentModal = Modal.getInstance(document.getElementById('item_modal'));
     if (parentModal) parentModal.show();
    }, 100);
   },

   openTaxModal() {
    const modalEl = document.getElementById('tax_modal');
    const modal = new Modal(modalEl);
    modal.show();
       
    setTimeout(() => {
     const parentModal = Modal.getInstance(document.getElementById('item_modal'));
      if (parentModal) parentModal.show();
     }, 100);
   },

   onGroupSaved() {
    this.getGroups();
   },

   onTaxSaved() {
    this.getTaxes();
   },

   resetForm() {
    this.id = null;
    this.finalGroupId = '';
    this.groupLevels = [];
    this.groupPath = [];
    this.branch_ids = [];
    this.tax_id = '';
    this.brand_id = '';
    this.image_preview = null;
    this.marketing_pdf = null;
    this.show_remove_pdf = 0;
    this.name = '';
    this.code = '';
    this.unit = '';
  this.calculation_type = 'standard';
  this.inventory_type = 'finish';
  this.units = this.standardUnits;
    this.hsn_code = '';
    this.price = '';
    this.type = 'product';
    this.description = '';
    this.errors = {};
    this.low_stock_threshold = '';
    this.rmt_width_multiplier = '';
    this.rmt_height_multiplier = '';
   },
  },
};
</script>

<template>
  <!-- Add Item Modal -->
  <div class="modal fade" id="item_modal">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content item-modal-wrap">

        <!-- Header -->
        <div class="modal-header item-modal-hdr">
          <div class="d-flex align-items-center gap-2">
            <span class="item-hdr-icon">
              <i class="ti ti-box"></i>
            </span>
            <h5 class="modal-title mb-0 fw-semibold">{{ id ? 'Edit Item' : 'Add Item' }}</h5>
          </div>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>

        <form @submit.prevent="submitItem" enctype="multipart/form-data">
          <div class="modal-body item-modal-body">


            <!-- Marketing PDF hidden -->
            <div class="col-md-5 d-none">
              <div class="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                <div class="d-flex align-items-center justify-content-center avatar-xxl bg-white rounded border border-dashed me-2 flex-shrink-0 text-dark frames px-2">
                  <i v-if="!show_remove_pdf" class="ti ti-file-text fs-40 text-muted"></i>
                  <a v-else :href="marketing_pdf_preview" target="_blank">View</a>
                </div>
                <div class="profile-upload">
                  <div class="mb-2">
                    <h6 class="mb-1">Marketing PDF</h6>
                    <p class="fs-12 text-muted">Catalog / Proposal (PDF only)</p>
                  </div>
                  <div class="profile-uploader d-flex align-items-center">
                    <div class="drag-upload-btn btn btn-sm btn-outline-primary me-2">
                      Choose PDF
                      <input type="file" class="form-control image-sign" accept=".pdf" @change="handleMarketingPdfUpload"/>
                    </div>
                    <a href="javascript:void(0);" class="text-danger small" v-if="show_remove_pdf" @click="removeMarketingPdf">Remove</a>
                  </div>
                  <div v-if="errors.marketing_pdf" class="text-danger small mt-1">{{ errors.marketing_pdf[0] }}</div>
                </div>
              </div>
            </div>

            <div>
              <div class="row">
                <!-- Type -->
                <div class="col-6">
                  <label class="item-label">Type</label>
                  <div class="d-flex gap-3 flex-wrap mt-1">
                    <div class="form-check form-check-inline form-checkbox-success mb-0">
                      <input type="radio" class="form-check-input me-2" name="type" id="type_product" value="product" v-model="type">
                      <label class="form-check-label item-label" for="type_product">Product</label>
                    </div>
                    <div class="form-check form-check-inline form-checkbox-success mb-0">
                      <input type="radio" class="form-check-input me-2" name="type" id="type_service" value="service" v-model="type">
                      <label class="form-check-label item-label" for="type_service">Service</label>
                    </div>
                  </div>
                  <div v-if="errors.type" class="text-danger fs-11 mt-1">{{ errors.type[0] }}</div>
                </div>

                <!-- ── ITEM IMAGE ── -->
                <div class="item-section col-6">
                  <div class="item-section-title">ITEM IMAGE</div>
                  <div class="d-flex align-items-center gap-3 flex-wrap">
                    <img v-if="image_preview" :src="image_preview" alt="Image" class="item-thumb" />
                      <i v-else class="ti ti-photo fs-24 text-muted"></i>
                    <div>
                      <p class="text-muted mb-2" style="font-size:12px;">Recommended: 250×250px</p>
                      <div class="d-flex gap-2 flex-wrap">
                        <label class="btn btn-sm btn-primary mb-0">
                          <i class="ti ti-upload me-1"></i>Change
                          <input type="file" class="d-none form-control image-sign" @change="handleImageUpload" />
                        </label>
                        <a v-if="show_remove" href="javascript:void(0);"
                          class="btn btn-sm btn-outline-danger" @click="removeFile">
                          <i class="ti ti-trash me-1"></i>Remove
                        </a>
                      </div>
                      <div v-if="errors.image" class="text-danger mt-1 fs-11">{{ errors.image[0] }}</div>
                    </div>
                  </div>
                </div>
              </div>

            </div>


            <!-- ── CATEGORIZATION ── -->
            <div class="item-section">
              <div class="item-section-title">CATEGORIZATION</div>
              <div class="row g-3">

                <!-- Item Group -->
                <div class="col-12" v-if="getPermission('Item_Group', 'read')">
                  <label class="item-label" v-if="groupLevels.some(l => l.length > 0)">
                    Item Group <span class="text-danger">*</span>
                  </label>

                  <div v-if="leaf_path" class="item-path-badge mb-2">
                    <i class="ti ti-folder-open me-1"></i>{{ leaf_path }}
                  </div>

                  <div v-for="(levelGroups, levelIndex) in groupLevels" :key="`level-${levelIndex}`">
                    <div v-if="levelGroups.length > 0" class="mb-2">
                      <label class="item-level-label">
                        <span class="item-level-badge">{{ levelIndex + 1 }}</span>
                        {{ levelIndex === 0 ? 'Main Category' : `Sub Category Level ${levelIndex + 1}` }}
                      </label>
                      <select class="form-select form-select-sm" @change="onGroupLevelChange(levelIndex, $event)" :disabled="loadingGroups">
                        <option value="">— Select Category —</option>
                        <option v-for="group in levelGroups" :key="group.id" :value="group.id">{{ group.name }}</option>
                      </select>
                    </div>
                  </div>

                  <input type="hidden" :value="finalGroupId" name="item_group_id" />
                  <div v-if="errors.item_group_id" class="text-danger fs-11 mt-1">{{ errors.item_group_id[0] }}</div>
                  <div v-if="loadingGroups" class="text-muted fs-11 mt-1">
                    <i class="ti ti-loader-2 me-1"></i>Loading categories...
                  </div>
                </div>

              </div>
            </div>


            <hr class="item-divider" />

            <!-- ── BASIC INFORMATION ── -->
            <div class="item-section">
              <div class="item-section-title">BASIC INFORMATION</div>
              <div class="row g-3">


                <!-- Name -->
                <div class="col-md-4 col-12">
                  <label class="item-label">Item Name <span class="text-danger">*</span></label>
                  <input type="text" class="form-control form-control-sm" v-model="name" />
                  <div v-if="errors.name" class="text-danger fs-11 mt-1">{{ errors.name[0] }}</div>
                </div>

                <!-- Code -->
                <div class="col-md-3 col-6">
                  <label class="item-label">Item Code <span class="text-danger">*</span></label>
                  <input type="text" class="form-control form-control-sm" v-model="code" />
                  <div v-if="errors.code" class="text-danger fs-11 mt-1">{{ errors.code[0] }}</div>
                </div>

                <!-- Brand -->
                <div class="col-md-3 col-12">
                  <label class="item-label">Brand</label>
                  <vue-select :options="brands" label="name" v-model="brand_id" placeholder="Select Brand" :reduce="b => b.id" />
                  <div v-if="errors.brand_id" class="text-danger fs-11 mt-1">{{ errors.brand_id[0] }}</div>
                </div>

                <!-- Price -->
                <div class="col-md-2 col-6">
                  <label class="item-label">Price <span class="text-danger">*</span></label>
                  <input type="text" class="form-control form-control-sm" v-model="price" />
                  <div v-if="errors.price" class="text-danger fs-11 mt-1">{{ errors.price[0] }}</div>
                </div>

                <!-- Calculation Type -->
                <div class="col-md-4 col-12">
                  <label class="item-label">Calculation Type</label>
                  <select class="form-select form-select-sm" v-model="calculation_type" @change="onCalculationTypeChange" >
                    <option value="standard">Standard</option>
                    <option value="dimensional">Dimensional</option>
                  </select>
                  <div v-if="errors.calculation_type" class="text-danger fs-11 mt-1">{{ errors.calculation_type[0] }}</div>
                </div>

              <!-- Inventory Type -->
              <div class="col-md-4 col-12">
                <label class="item-label">Inventory Type </label>
                <select class="form-select form-select-sm" v-model="inventory_type">
                  <option value="finish">Finish</option>
                  <option value="raw">Raw</option>
                </select>
                <div v-if="errors.inventory_type" class="text-danger fs-11 mt-1">{{ errors.inventory_type[0] }}</div>
              </div>

                <!-- Unit -->
                <div class="col-md-4 col-12">
                  <label class="item-label">Unit</label>
                  <vue-select :options="units" label="label" :reduce="u => u.value" v-model="unit" placeholder="Select" />
                  <div v-if="errors.unit" class="text-danger fs-11 mt-1">{{ errors.unit[0] }}</div>
                </div>

                <!-- Rmt Multipliers — only when unit is Rmt -->
                <template v-if="unit === 'Rmt'">
                    <div class="col-md-4 col-6">
                        <label class="item-label">Width Multiplier <span class="text-danger">*</span></label>
                        <input type="number" class="form-control form-control-sm" v-model="rmt_width_multiplier" placeholder="e.g. 2" min="0" step="any" />
                        <div v-if="errors.rmt_width_multiplier" class="text-danger fs-11 mt-1">{{ errors.rmt_width_multiplier[0] }}</div>
                    </div>
                    <div class="col-md-4 col-6">
                        <label class="item-label">Height Multiplier <span class="text-danger">*</span></label>
                        <input type="number" class="form-control form-control-sm" v-model="rmt_height_multiplier" placeholder="e.g. 2" min="0" step="any" />
                        <div v-if="errors.rmt_height_multiplier" class="text-danger fs-11 mt-1">{{ errors.rmt_height_multiplier[0] }}</div>
                    </div>
                </template>

                <!-- HSN Code -->
                <div class="col-md-4 col-12">
                  <label class="item-label">HSN Code</label>
                  <input type="text" class="form-control form-control-sm" v-model="hsn_code" />
                  <div v-if="errors.hsn_code" class="text-danger fs-11 mt-1">{{ errors.hsn_code[0] }}</div>
                </div>

                <!-- Low Stock Threshold -->
                <div class="col-md-4 col-12" v-if="getPermission('Stock', 'read')">
                  <label class="item-label">Low Stock Threshold</label>
                  <input type="number" class="form-control form-control-sm" v-model="low_stock_threshold" min="0" placeholder="Enter threshold" />
                  <div v-if="errors.low_stock_threshold" class="text-danger fs-11 mt-1">{{ errors.low_stock_threshold[0] }}</div>
                </div>

                <!-- Tax -->
                <div class="col-md-4 col-12">
                  <label class="item-label d-flex justify-content-between align-items-center">
                    Tax
                    <a href="javascript:void(0);" class="text-primary item-add-link" @click="openTaxModal">
                      <i class="ti ti-plus me-1"></i>Add New
                    </a>
                  </label>
                  <select class="form-select form-select-sm" v-model="tax_id">
                    <option value="">Choose any</option>
                    <option v-for="row in taxes" :key="row.id" :value="row.id">{{ row.name }}</option>
                  </select>
                  <div v-if="errors.tax_id" class="text-danger fs-11 mt-1">{{ errors.tax_id[0] }}</div>
                </div>

                <!-- Branch -->
                <div class="col-md-4 col-12">
                  <label class="item-label">Branches</label>
                  <vue-select :options="branches" v-model="branch_ids" label="name" :reduce="branch => branch.id" placeholder="Select Branches" multiple />
                  <div v-if="errors.branch_ids" class="text-danger fs-11 mt-1">{{ errors.branch_ids[0] }}</div>
                </div>

              </div>
            </div>


            <hr class="item-divider" />

            <!-- ── DESCRIPTION ── -->
            <div class="item-section">
              <div class="item-section-title">DESCRIPTION</div>
              <ckeditor :editor="editor" v-model="description" :config="editorConfig"></ckeditor>
              <div v-if="errors.description" class="text-danger fs-11 mt-1">{{ errors.description[0] }}</div>
            </div>

            <hr class="item-divider" />


          </div>

          <!-- Footer -->
          <div class="modal-footer item-modal-ftr">
            <button type="button" class="btn btn-light item-btn-cancel" data-bs-dismiss="modal">Cancel</button>
            <button type="submit" class="btn btn-danger item-btn-save" :disabled="loadingGroups">
              {{ id ? 'Update Item' : 'Save Item' }}
            </button>
          </div>
        </form>

      </div>
    </div>
  </div>

  <!-- Delete Modal -->
  <div class="modal fade" id="item_delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content item-modal-wrap">
        <div class="modal-body text-center" style="padding:40px 24px;">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1 fw-semibold">Confirm Delete</h4>
          <p class="mb-4 text-muted" style="font-size:13px;">
            You want to delete all the marked items, this can't be undone once you delete.
          </p>
          <div class="d-flex justify-content-center gap-2 flex-wrap">
            <a href="javascript:void(0);" class="btn btn-light item-btn-cancel" data-bs-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-danger item-btn-save" @click="deleteItem">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <item-group-modal @updated="onGroupSaved"></item-group-modal>
  <tax-modal @updated="onTaxSaved"></tax-modal>
</template>

<style scoped>
/* ── Modal shell ── */
.item-modal-wrap {
  border: none;
  border-radius: 12px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.13);
  overflow: hidden;
}

/* ── Header ── */
.item-modal-hdr {
  border-bottom: 1px solid #f0f0f0;
  padding: 14px 20px;
}

.item-hdr-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fde8e8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #e84040;
  font-size: 15px;
  flex-shrink: 0;
}

/* ── Body ── */
.item-modal-body {
  padding: 0 20px 8px;
  max-height: 70vh;
  overflow-y: auto;
}

/* ── Section ── */
.item-section {
  padding: 16px 0 10px;
}

.item-section-title {
  font-size: 11px;
  font-weight: 700;
  color: #9e9e9e;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 14px;
}

/* ── Divider ── */
.item-divider {
  border-color: #f0f0f0;
  margin: 4px 0 0;
}

/* ── Image thumb ── */
.item-thumb {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #e8eaf0;
  flex-shrink: 0;
}

/* ── Label ── */
.item-label {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 5px;
  display: block;
}

/* ── Path badge ── */
.item-path-badge {
  display: inline-flex;
  align-items: center;
  background: #fff8f0;
  border: 1px solid #ffe0b2;
  border-radius: 20px;
  padding: 3px 12px;
  font-size: 12px;
  color: #e65100;
}

/* ── Level label ── */
.item-level-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  color: #9e9e9e;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.item-level-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background: #e84040;
  color: #fff;
  border-radius: 50%;
  font-size: 9px;
  font-weight: 700;
  flex-shrink: 0;
}

/* ── Add link ── */
.item-add-link {
  font-size: 11px;
  font-weight: 400;
}

/* ── Inputs & Selects ── */
.form-control,
.form-control-sm,
.form-select,
.form-select-sm {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 13px;
  color: #333;
  padding: 8px 12px;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.form-control:focus,
.form-control-sm:focus,
.form-select:focus,
.form-select-sm:focus {
  border-color: #bdbdbd;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);
  outline: none;
}

/* ── Footer ── */
.item-modal-ftr {
  border-top: 1px solid #f0f0f0;
  padding: 12px 20px;
  gap: 10px;
}

.item-btn-cancel {
  font-size: 13px;
  padding: 7px 24px;
}

.item-btn-save {
  font-size: 13px;
  padding: 7px 24px;
}

/* ── Responsive: tablet (max 768px) ── */
@media (max-width: 768px) {
  .modal-lg {
    max-width: 96vw;
    margin: 10px auto;
  }

  .item-modal-body {
    max-height: 65vh;
    padding: 0 14px 8px;
  }

  .item-modal-hdr {
    padding: 12px 14px;
  }

  .item-modal-ftr {
    padding: 10px 14px;
    flex-wrap: wrap;
  }

  .item-btn-cancel,
  .item-btn-save {
    flex: 1;
    text-align: center;
  }

  .item-thumb {
    width: 52px;
    height: 52px;
  }
}

/* ── Responsive: mobile (max 480px) ── */
@media (max-width: 480px) {
  .modal-lg {
    max-width: 100vw;
    margin: 0;
  }

  .item-modal-wrap {
    border-radius: 0;
    min-height: 100vh;
  }

  .item-modal-body {
    max-height: calc(100vh - 130px);
    padding: 0 12px 8px;
  }

  .item-section-title {
    font-size: 10px;
  }

  .item-label {
    font-size: 12px;
  }

  .item-btn-cancel,
  .item-btn-save {
    width: 100%;
  }
}
</style>